import { AdalService } from 'adal-angular4';
import { Component, OnInit} from '@angular/core';
import { RuntimeConfigService } from './shared/services/runtime-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit{
    title = 'app';
    constructor(private adalService: AdalService, private runtimeConfigService: RuntimeConfigService) {
      adalService.init(this.runtimeConfigService.getAuthConfig());
    }

    ngOnInit() {
      // Handle callback if this is a redirect from Azure
      this.adalService.handleWindowCallback();
    }
}
